// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2KLdc","Success":"Button_Success__2jcXh","Danger":"Button_Danger__1h3s1"};